import { useSelector } from 'react-redux';
import { AccountApplication } from 'src/models';

interface UseAccountApplicationSelectorReturnType {
  accountApplication?: AccountApplication;
  isAccountApplicationLoading: boolean;
  hasAccountApplicationError: boolean;
  hasAccountApplicationSucceeded: boolean;
  accountApplicationError?: string;
  isAnyAccountApplicationDocumentRequested: boolean;
}

export const useAccountApplicationSelector = (): UseAccountApplicationSelectorReturnType => {
  const application: AccountApplication | undefined = useSelector(
    (state: any) => state.accountApplications.details.data,
  );
  const isLoading: boolean = useSelector((state: any) => state.accountApplications.details?.isLoading);
  const isSuccess: boolean = useSelector((state: any) => Boolean(state.accountApplications.details?.__succeeded));
  const hasError: boolean = useSelector((state: any) => Boolean(state.accountApplications.details?.__failed));
  const error: string | undefined = useSelector((state: any) => state.accountApplications.details?.__message);

  return {
    accountApplication: application,
    isAccountApplicationLoading: isLoading,
    hasAccountApplicationError: hasError,
    hasAccountApplicationSucceeded: isSuccess,
    accountApplicationError: error,
    isAnyAccountApplicationDocumentRequested: application?.categories.some(category => !category.isResolved) ?? false,
  };
};
